<template>
  <div>home</div>
    
</template>

<script>
// import axios from 'axios'
export default {
  name: 'Home',
  created(){
    //   console.log(this.$route)
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
